import React from "react";
import styles from "../styles.module.scss";
import useTranslation from "next-translate/useTranslation";
import { CUSTOMER_SUPPORT } from "../../../../utils/i18nNameSpaces";
import bg from "/public/contactus/bg.svg";
import Image from "next/image";

const Index = ({ t }) => {
  return (
    <section className={styles["hero"]}>
      <div className={styles["hero-bg"]}>
        <Image
          src={bg}
          quality={100}
          priority
          alt="background"
          objectFit={"cover"}
          layout={"fill"}
        />
      </div>
      <div className={styles["container"]}>
        <p className={styles["subhead"]}>{t("hero.subhead")}</p>
        <div className={styles["header-wrapper"]}>
          <h1>
            <span>{t("hero.header._1")}</span>
            <span>{t("hero.header._2")}</span>
          </h1>
        </div>
        <p>{t("hero.text1")}</p>
        <p>{t("hero.text2")}</p>
      </div>
    </section>
  );
};

export default Index;
